var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41996 15.4656L5.59721 18.537L2.59008 18.6006C1.69139 16.9338 1.18164 15.0266 1.18164 13C1.18164 11.0403 1.65825 9.1922 2.50306 7.56494H2.50371L5.1809 8.05576L6.35366 10.7169C6.10821 11.4325 5.97442 12.2007 5.97442 13C5.97451 13.8675 6.13166 14.6987 6.41996 15.4656Z",
    fill: "#FBBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6116 10.7922C24.7474 11.5071 24.8181 12.2454 24.8181 13C24.8181 13.8461 24.7292 14.6714 24.5597 15.4675C23.9844 18.1766 22.4811 20.5422 20.3987 22.2162L20.398 22.2156L17.026 22.0435L16.5487 19.0643C17.9305 18.2539 19.0104 16.9857 19.5793 15.4675H13.2598V10.7922H19.6715H24.6116Z",
    fill: "#518EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3981 22.2156L20.3988 22.2163C18.3735 23.8442 15.8007 24.8182 13.0001 24.8182C8.49942 24.8182 4.58645 22.3026 2.59033 18.6007L6.42021 15.4656C7.41824 18.1293 9.98773 20.0254 13.0001 20.0254C14.2949 20.0254 15.5079 19.6754 16.5488 19.0643L20.3981 22.2156Z",
    fill: "#28B446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5432 3.90259L16.7146 7.03699C15.6374 6.36364 14.364 5.97465 12.9997 5.97465C9.91916 5.97465 7.30162 7.95775 6.35358 10.7169L2.50358 7.56493H2.50293C4.46983 3.77273 8.43215 1.18182 12.9997 1.18182C15.8672 1.18182 18.4964 2.20327 20.5432 3.90259Z",
    fill: "#F14336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.dd9752711694d3e30b679dfaf5774a5e.svg";
export { ForwardRef as ReactComponent };